import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-applications-link',
  templateUrl: './applications-link.component.html',
  styleUrls: ['./applications-link.component.css']
})
export class ApplicationsLinkComponent implements OnInit {
  title: string;
  height: string;
  width: string;
  srcLink: any;
  app: any;
  url: SafeResourceUrl;
  smallerDevice: boolean;

  constructor( public dialogRef: MatDialogRef<ApplicationsLinkComponent>,  @Inject(MAT_DIALOG_DATA) data, public sanitizer: DomSanitizer) {
    this.title = data.title;
    this.height = data.height;
    this.width = data.width;
    this.app = data.app;
    if (screen.width <= 1300) {
      this.smallerDevice = true;
    } else {
      this.smallerDevice = false;
    }
  }

  ngOnInit() {
      /* if (this.app == 'HVSLTCMap') {
        this.srcLink = 'https://la.hvsfinancial.com/Applications/' + this.app;
      } else {
        this.srcLink = 'https://la.hvsfinancial.com/tools/' + this.app;
      }
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.srcLink); */
      //console.log('app url', this.app);
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.app);
      this.srcLink = this.app;
  }

  popOut(){
    var winFeature = 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,' + 'width=' + this.width + ', height=' + this.height;
    window.open(this.srcLink, 'window', winFeature);

    //TODO: since these are independant apps, poping out will reload the app of any progress, should we notify user?
    //since we poped out the app, we dont need the modal anymore
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
